import Start from "./View";
import StartContainer from "./Container";

export { Start };
export default StartContainer;
